const toolbox = {
  kind: 'categoryToolbox',
  contents: []
}

export default toolbox
